<script setup lang="ts">
import { OCS_SPECIAL_CHAR_PWD } from "@/utils/misc.utils";
</script>

<template>
  <div class="alert alert-info" role="alert">
    {{ $t("auth:login.password_requirements") }} {{ OCS_SPECIAL_CHAR_PWD }}
  </div>
</template>
